// Environment configuration loader
import devEnvironment from './environment.dev.json';
import prodEnvironment from './environment.prod.json';

// Select config based on environment (default to prod for safety)
const ENV = process.env.REACT_APP_ENV || 'prod';
const environmentConfig = ENV === 'dev' ? devEnvironment : prodEnvironment;

class Config {
  constructor() {
    this.config = environmentConfig;
    this.env = ENV;
  }

  get apiBaseUrl() {
    return this.config.url;
  }

  get awsBucket() {
    return this.config.awsBucket;
  }

  get quizBaseUrl() {
    return this.config.quizBaseUrl;
  }

  // API endpoint builders
  getSessionEndpoint() {
    return `${this.apiBaseUrl}/api/v1/session/`;
  }

  getChatEndpoint() {
    return `${this.apiBaseUrl}/api/v1/chat/`;
  }

  getProfileEndpoint() {
    return `${this.apiBaseUrl}/api/v1/profile/`;
  }

  getProfileAttributeEndpoint() {
    return `${this.apiBaseUrl}/api/v1/profile/attribute`;
  }
}

// Export singleton instance
const config = new Config();
export default config;
